<template>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">专为您的 FR3 定制</span>
        <h1>FRANKA AI 伙伴</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
            帮助您更轻松、更高效地完成更多任务。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">  
              <router-link to="/contact" class="buttonSite">联系我们</router-link>  
          </div>
      </div>
  
      <div class="display-width">
        <img src="@/assets/images/events/image (3).png" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
    
    <div id="resources-productdocumentation"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">功能</span>
      <hr class="divider">
    </div>
    <div class="px-container"> 
        <div class="c-text-between  c-flex-wrap " >
            <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;margin-bottom: 60px;"> 
              <h2>GPU 功率与实时控制的集成</h2> 
              <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;"> 
                通过将 AI 模型与实时机器人控制集成在同一平台上，您可以在执行诸如物体检测与抓取规划等任务时，无需依赖外部资源。
              </span> 
            </div>  
            <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;margin-bottom: 60px;"> 
              <h2>简化的研究设置</h2> 
              <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;"> 
                通过集成 Docker 容器（例如 LLMs 和视觉模型）的沙盒开发环境，轻松创建、管理和切换研究设置。
              </span>  
            </div>  
        </div> 
        <div class="c-text-between  c-flex-wrap " >
            <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;margin-bottom: 60px;"> 
              <h2>GPU 扩展能力</h2> 
              <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;"> 
                开箱即用，兼容不断扩展的各种流行硬件设备（如 Intel® RealSense™）和软件组件。
              </span> 
            </div>  
            <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;margin-bottom: 60px;"> 
              <h2>多用户、多实验管理</h2> 
              <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;"> 
                快速在同一实验室内传输设置和数据，或与其他机构共享，促进研究结果和方法的传播，从而推动合作。
              </span>  
            </div>  
        </div> 
        <div class="c-text-between  c-flex-wrap " >
            <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;margin-bottom: 60px;"> 
              <h2>不断发展的生态系统</h2> 
              <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;"> 
                Franka AI 伙伴是 Franka 生态系统增强功能之一，与 Franka MATLAB 工具箱和 Franka ROS 2 等产品互补并轻松集成。这些协同作用使您能够利用 Franka 机器人强大的数据采集和实时控制能力。
              </span> 
            </div>   
        </div> 
      </div>
 
    <!-- <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">计算能力</span>
      <hr class="divider">
    </div> -->
    
    <!-- <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1>NVIDIA® Jetson Orin™ NX</h1>
        <span class="c-mt-5 c-mb-5 c-text-left text-indent c-font-weight">
            16 GB 内存
        </span> 
        <span class="c-mt-5 c-mb-5 c-text-left text-indent c-font-weight">
            500 GB 固态硬盘
        </span> 
        <span class="c-mt-5 c-mb-5 c-text-left text-indent c-font-weight">
            接口：
        </span> 
        <span class="c-mt-5 c-mb-5 c-text-left text-indent">
            3个 USB 3.1 C-Type
        </span> 
        <span class="c-mt-5 c-mb-5 c-text-left text-indent">
            双千兆以太网
        </span> 
        <span class="c-mt-5 c-mb-5 c-text-left text-indent">
            HDMI
        </span> 
        <span class="c-mt-5 c-mb-5 c-text-left text-indent">
            数字输入/输出
        </span> 
        <span class="c-mt-5 c-mb-5 c-text-left text-indent">
            RS323、RS422 和 CAN 总线
        </span> 
        <img src="@/assets/images/events/nvidia-3.png" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
      <div class="display-width">
        <img src="@/assets/images/events/Franka AI Companion-no_bg-1.png" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div> -->
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">研发灵活性</span>
      <hr class="divider">
    </div> 
    
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1>丰富的应用场景</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
            • 在多个不兼容的软件堆栈之间快速切换。
        </span>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
            • 通过切换 Docker 容器快速评估多个机器学习模型。
        </span> 
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
            • 结合实时视觉伺服进行物体检测。
        </span> 
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
            • 将与实验相关的软件设置直接附加到论文中以供审阅。
        </span> 
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
            • 独立于 PC 的研究工作设置与执行。
        </span>
        <div class="linkTag"> 
            <router-link to="/contact">联系我们</router-link> 
        </div>
      </div> 
    </div>
  </template>
  
  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {  
        
      }
    }, 
  }
  </script>
  
  <style scoped>
  
  .display-width{
    width: calc(50% - 40px);
  }
  
@media (max-width: 1029px) {
  }
  
  /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .display-width{
      width: 100%
    }
  }
  
  /* 屏幕宽度小于 600px 时，一行展示 1 个 */
  @media (max-width: 599px) {
  }
  
  </style>
  <style scoped> 
  /* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
  </style>
  